import { Box, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetDashboardOrderHistoryQuery } from "../../../../newapi/reports/fulfillment/reportFulfillmentSlice";
import { tokens } from "../../../../theme";
import { MultiChart } from "../../../theme/charts/HorizontalBarChart";
import Heading from "../../../theme/text/Heading";


export const OrderHistoryChart = (props) => {
    const { t, ready } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {data: chartData, isLoading, isFetching, isError,refetch} = useGetDashboardOrderHistoryQuery(undefined, { skip: props.preview });
    const [data, setData] = useState(null);
    
    const handleRetry = () => {
        refetch();
    };

    useEffect(() => {
        if(!isLoading && !isFetching) {
            const series = chartData?.values.map((item, index) => ({
                name: item.name,
                type: index === 0 ? 'bar' : 'line', // first is bar, second is line
                data: item.data
            }));
            setData(series ?? [0]);
        }
    },[chartData,isLoading,isFetching])

    return (
        <Box
            sx={props.sx ?? {
                // overflow:"hidden",
                "@media screen and (max-width: 768px)" : {
                    gridArea: "2 / 1 / 3 / 3",
                }
            }}
        >
            {data &&
                <MultiChart
                    height={"100%"}
                    // hideFilter
                    optionsEnabled={false}
                    title={t("orders_through_time")}
                    subtitle={t("orders_through_time_subtitle")}
                    type="area"
                    staticColors={[
                        colors.green[400],
                        theme.palette.mode === "dark" ? colors.white[400] : colors.grey[400],
                    ]}
                    filter={
                        <Box>
                            <Heading
                                sx={{
                                    fontWeight:"1000",
                                    color:colors.green[400],
                                }}
                            >
                                {chartData?.values[0]?.data?.reduce((a, b) => a + b, 0)}
                            </Heading>
                            {/* <Text light>
                                {t("total")}
                            </Text> */}
                        </Box>
                    }
                    colors={['green']}
                    isError={isError}
                    isLoading={isLoading || isFetching}
                    categories={chartData?.categories}
                    values={data}
                    background={theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[50]}
                    color={'default'}
                    onRetry={handleRetry}
                    tickAmount={30}
                />
            }

        </Box>
    );
}